import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ConvertIdeaToKaizenGQL, ConvertIdeaToKaizenMutation, ConvertIdeaToKaizenMutationVariables } from "src/generated/graphql/idea/idea.graphql";
import { IIdeaFiles } from "../interfaces/idea";
import { DeleteFileMutation, DeleteFileMutationVariables, DeleteIdeaFileGQL } from "src/generated/graphql/idea/idea-file/delete-file.graphql";
import { GetAllIdeaFilesGQL, GetAllIdeaFilesMutation, GetAllIdeaFilesMutationVariables } from "src/generated/graphql/idea/idea-file/get-all-files.graphql";

@Injectable({
  providedIn: "root",
})
export class IdeaService {
  constructor(
    private convertIdeaToKaizenGQL: ConvertIdeaToKaizenGQL,
    private deleteIdeaFileGQL: DeleteIdeaFileGQL,
    private getAllIdeaFilesGQL: GetAllIdeaFilesGQL,
    private http: HttpClient
  ) {}

  convertIdeaToKaizen({ id }: ConvertIdeaToKaizenMutationVariables): Observable<ConvertIdeaToKaizenMutation> {
    return this.convertIdeaToKaizenGQL.mutate({ id }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to convert idea actions"));
      })
    )
  }

  uploadFile(id: string, dir: string, file: FormData): Observable<IIdeaFiles> {
    return this.http.post<IIdeaFiles>(environment.base_url + `/ideas/file/${id}/${dir}`, file).pipe(
      map((result) => {
        return result
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to upload idea file"));
      })
    )
  }

  deleteFile({ id }: DeleteFileMutationVariables): Observable<DeleteFileMutation> {
    return this.deleteIdeaFileGQL.mutate({ id }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to delete idea file"));
      })
    )
  }

  getAllIdeaFiles({ id }: GetAllIdeaFilesMutationVariables): Observable<GetAllIdeaFilesMutation> {
    return this.getAllIdeaFilesGQL.mutate({ id }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to get all files"));
      })
    )
  }
}
